import is from 'is_js';
import React, { Component, ChangeEvent } from "react";
import MUIPlacesAutoComplete from 'mui-places-autocomplete';
import DialogAddressPickerViewStyle from './DialogAddressPickerViewStyle';
import DialogAddressPickerViewProps from './DialogAddressPickerViewProps';
import TranslationView from "../../../../../../components/Translation/TranslationView";

export default class DialogAddressPickerView extends Component<DialogAddressPickerViewProps> {

    private _style = new DialogAddressPickerViewStyle();

    private _onChange = (address : string) => {
        this.props.onChange(address);
    }

    render() {
        const { error } = this.props;
        return (
            <div style={this._style.addressInput}>
                <MUIPlacesAutoComplete
                    onSuggestionSelected={(suggestion : any) => this._onChange(suggestion.description)}
                    renderTarget={() => <div />}
                    textFieldProps={{ 
                        label : TranslationView.translate(this.props.label), 
                        onChange : (event : ChangeEvent<HTMLInputElement>) => this._onChange(event.target.value),
                        value : this.props.value,
                        style : this._style.label,
                        autoComplete:is.chrome() ? "nope" : 'false',
                        error : !!this.props.error,
                        helperText : error ? TranslationView.translate(error) : " "
                    }} />
            </div>
        );  
    }
}